import { getLanuageISO2Codes } from "../../utils/translations.util";
// Normalize PMS aliases for display and comparison without rewriting stored language codes.
var LANGUAGE_ALIASES = { d: 'de', e: 'en', i: 'it', f: 'fr', eng: 'en', nb: 'no', he: 'iw', heb: 'iw' };
var ISO_LANGUAGES = new Set(getLanuageISO2Codes());
export var normalizeLanguageCode = function (code) {
    var _a, _b, _c;
    var raw = (_a = code === null || code === void 0 ? void 0 : code.trim().toLowerCase()) !== null && _a !== void 0 ? _a : '';
    var base = raw.split(/[-_]/)[0];
    var language = (_c = (_b = LANGUAGE_ALIASES[raw]) !== null && _b !== void 0 ? _b : LANGUAGE_ALIASES[base]) !== null && _c !== void 0 ? _c : base;
    return ISO_LANGUAGES.has(language) ? language : raw;
};
export var sameLanguage = function (left, right) { return normalizeLanguageCode(left) === normalizeLanguageCode(right); };
export var uniqueLanguages = function (codes) { return codes
    .map(function (language) { return language === null || language === void 0 ? void 0 : language.trim(); })
    .filter(function (language, index, all) {
    return !!language && all.findIndex(function (other) { return sameLanguage(other, language); }) === index;
}); };
